import { render, staticRenderFns } from "./UnterrichtUserWidget.vue?vue&type=template&id=f2f2d8ba&scoped=true"
import script from "./UnterrichtUserWidget.vue?vue&type=script&lang=ts"
export * from "./UnterrichtUserWidget.vue?vue&type=script&lang=ts"
import style0 from "./UnterrichtUserWidget.vue?vue&type=style&index=0&id=f2f2d8ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f2d8ba",
  null
  
)

export default component.exports